import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "building",
  "use": "building-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill-rule=\"evenodd\" viewBox=\"0 0 24 24\" id=\"building\"><path d=\"M1 22h2V0h18v22h2v2H1v-2zm7-3v4h3v-4H8zm5 0v4h3v-4h-3zm-6-5H5v2h2v-2zm8 0h-2v2h2v-2zm-4 0H9v2h2v-2zm8 0h-2v2h2v-2zM7 10H5v2h2v-2zm8 0h-2v2h2v-2zm-4 0H9v2h2v-2zm8 0h-2v2h2v-2zM7 6H5v2h2V6zm8 0h-2v2h2V6zm-4 0H9v2h2V6zm8 0h-2v2h2V6zM7 2H5v2h2V2zm8 0h-2v2h2V2zm-4 0H9v2h2V2zm8 0h-2v2h2V2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/building.svg
// module id = vjBF
// module chunks = 1